export default __webpack_public_path__ + "static/media/linkedin.a2a02367.svg";